import { useEffect, useRef, useState } from 'react';
import { SignOut, UserCircle } from '@phosphor-icons/react';
import { initialen } from '../../../lib/immobilien/format';

/**
 * Nutzerkarte unten in der Sidebar (Listenmodus). Ein Klick öffnet das Menü mit
 * Profil und Abmelden – die Funktionen der klassischen Kopfleiste.
 */
export function Nutzerkarte({ name, rolle, email, avatarUrl, onProfil, onAbmelden, aktiv = false }: {
  /** Auf der Profilseite hervorgehoben (design_handoff_profil §7.3) */
  aktiv?: boolean;
  name?: string;
  rolle: string;
  email?: string;
  avatarUrl?: string;
  onProfil: () => void;
  onAbmelden: () => void;
}) {
  const [offen, setOffen] = useState(false);
  const huelle = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!offen) return;
    const aussen = (e: MouseEvent) => { if (huelle.current && !huelle.current.contains(e.target as Node)) setOffen(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOffen(false); };
    document.addEventListener('mousedown', aussen);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', aussen); document.removeEventListener('keydown', esc); };
  }, [offen]);

  const anzeige = name || email || 'Konto';
  const menueKnopf = 'immo-hover-flaeche flex items-center w-full cursor-pointer text-left';
  return (
    <div ref={huelle} className="relative" style={{ marginTop: 'auto' }}>
      {offen && (
        <div
          role="menu"
          className="immo-glas-stark immo-side-in absolute left-0 right-0 flex flex-col"
          style={{ bottom: '100%', marginBottom: 8, borderRadius: 16, padding: 6, zIndex: 20 }}
        >
          {email && <span className="truncate" style={{ padding: '6px 10px 8px', fontSize: 11, color: 'var(--ink3)' }}>{email}</span>}
          <button type="button" role="menuitem" onClick={() => { setOffen(false); onProfil(); }} className={menueKnopf}
            style={{ gap: 8, padding: '8px 10px', borderRadius: 10, border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>
            <UserCircle weight="bold" size={16} color="var(--acc)" />
            Profil
          </button>
          <button type="button" role="menuitem" onClick={() => { setOffen(false); onAbmelden(); }} className={menueKnopf}
            style={{ gap: 8, padding: '8px 10px', borderRadius: 10, border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, color: 'var(--bad)' }}>
            <SignOut weight="bold" size={16} />
            Abmelden
          </button>
        </div>
      )}
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={offen}
        onClick={() => setOffen(o => !o)}
        className="flex items-center w-full cursor-pointer text-left"
        aria-current={aktiv ? 'page' : undefined}
        style={{ gap: 10, padding: 8, borderRadius: 14, border: 'none', color: 'var(--ink)',
          background: aktiv ? 'var(--acc-soft)' : 'var(--fill)', boxShadow: aktiv ? 'inset 0 0 0 1px color-mix(in srgb, var(--acc) 25%, transparent)' : 'none' }}
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt="" style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
        ) : (
          <span className="flex items-center justify-center shrink-0"
            style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--acc-fill)', fontSize: 12, fontWeight: 700, color: 'var(--acc-ink)' }}>
            {initialen(anzeige)}
          </span>
        )}
        <span className="flex flex-col min-w-0">
          <span className="truncate" style={{ fontSize: 13, fontWeight: 500 }}>{anzeige}</span>
          <span style={{ fontSize: 11, color: 'var(--ink3)' }}>{rolle}</span>
        </span>
      </button>
    </div>
  );
}
